import Grid from "@mui/material/Unstable_Grid2";

const WidgetGroup = ({ children, className = "" }) => {
  return (
    <Grid className={`widget-group ${className}`} container xs={12}>
      {children}
    </Grid>
  );
};

export default WidgetGroup;
